import React from "react";
import { useState, useEffect, useLayoutEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import * as intchaine from "./interface-chaine";
import MonModal from "./MonModal";
import {DEBUG} from "./utilitaires";
// import {useAsync} from "react-async"

export default function ProfilFournisseur() {
  //pour le modal
  const [show, setShow] = useState(false);
  const [msgModal, setMsgModal] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [idF, setIdF] = useState(-1);

  const [nomF, setNomF] = useState("");
  const [identF, setIdentF] = useState("");
  const [addrPF, setAddrPF] = useState("");
  const [paysF, setPaysF] = useState("");
  const [compteF, setCompteF] = useState("");
  const [lotsF, setLotsF] = useState("");
  const [dateF, setDateF] = useState("");

  useEffect(() => {
    (async () => {
      let idftemp
      if (intchaine.accountFournisseur) {
        idftemp = await intchaine.getIdFournisseurParAdresse(intchaine.accountFournisseur);
      }
      setIdF(idftemp);
      if (idftemp > 0) {
        let infostemp = await intchaine.getInfosFournisseur(idftemp);
        setNomF(infostemp[0]);
        setIdentF(infostemp[1]);
        setAddrPF(infostemp[2]);
        setPaysF(infostemp[3]);
        setCompteF(infostemp[4]);

        let lesLotsArray = infostemp[5];
        let lotsText = lesLotsArray.join(", ");

        setLotsF(lotsText);

        let dateFLue = infostemp[6];
        let d = new Date(dateFLue * 1000);
        let dateFormat =
          d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();

        setDateF(dateFormat);
      }
    })();
  }, []);

  async function handleRafraichir(e) {
    e.preventDefault();
    let infostemp = await intchaine.getInfosFournisseur(idF);
    let lesLotsArray = infostemp[5];
    let lotsText = lesLotsArray.join(", ");
    setLotsF(lotsText);
  }

  if (!intchaine.accountFournisseur) {
    let msg = "Pas de compte selectionné sur Metamask";
    return (
      <>
        <MonModal titre={"Profil Fournisseur"} message={msg} montrer={true} />
      </>
    );
  } else {
    // console.log("id fournisseur ici: ", idF);
    if (idF == 0) {
      let msg = "Ce fournisseur n'existe pas sur la Blockchain";
      // console.log("not IDF");
      return (
        <>
          <p>Ce founisseur n'existe pas sur la blockchain</p>
          <MonModal titre={"Profil Fournisseur"} message={msg} montrer={true} />
        </>
      );
    } else if (idF>0) {
      return (
        <>
          <div
            style={{
              paddingLeft: "60px",
              // marginLeft: "50px",
              // marginRight: "50px",
              borderStyle: "solid",
              borderWidth: "2px",
            }}
          >
            <p><span style={{ color: "blue" }}>Fournisseur numero: </span> {idF}</p>
            <p ><span style={{ color: "blue" }}>Nom: </span>{nomF}</p>
            <p><span style={{ color: "blue" }}>Identification: </span>{identF}</p>
            <p><span style={{ color: "blue" }}>Adresse Postale: </span>{addrPF}</p>
            <p><span style={{ color: "blue" }}>Pays: </span>{paysF}</p>
            <p><span style={{ color: "blue" }}>Compte: </span>{compteF}</p>
            <p>
            <span style={{ color: "blue" }}>Lots déclarés: </span>{lotsF}{" "}
              <Button
                style={{ fontSize: 12, padding: 3 }}
                variant="outline-primary"
                onClick={handleRafraichir}
              >
                Rafraîchir
              </Button>
            </p>
            <p><span style={{ color: "blue" }}>Date d'enregistrement: </span>{dateF}</p>
          </div>
        </>
      );
    }
  }
}
